import React from 'react';
import { useGetJobsiteContainerJobsiteInfoQuery } from 'apollo/generated/client-operations';
import { LoadingError } from 'components/loadingError';
import { StaticMap } from '@vis.gl/react-google-maps';
import { useJobsiteStaticMapUrl } from 'utils/maps';
import { JobsiteInfoCard } from './components/JobsiteInfoCard';
import { JobsiteSelfOnboardingCard } from './components/JobsiteSelfOnboardingCard';

export type JobsiteOverviewInfoProps = {
  jobsiteId: string;
  baseRoute: string;
  onRefetchReady?: (refetch: () => void) => void;
};

export function JobsiteOverviewInfo({
  jobsiteId,
  baseRoute,
  onRefetchReady,
}: JobsiteOverviewInfoProps): React.ReactElement {
  const { data, loading, error, refetch } =
    useGetJobsiteContainerJobsiteInfoQuery({
      fetchPolicy: 'no-cache',
      notifyOnNetworkStatusChange: true,
      variables: {
        jobsiteId,
      },
    });

  const jobsite = data?.getJobsite;

  const staticMapUrl = useJobsiteStaticMapUrl(
    jobsite?.latitude,
    jobsite?.longitude,
  );

  React.useEffect(() => onRefetchReady?.(refetch), [onRefetchReady, refetch]);

  if (error) {
    return <LoadingError error={error} />;
  }

  return (
    <div className="odin-flex odin-flex-col odin-gap-6 lg:odin-flex-row lg:odin-items-stretch">
      {staticMapUrl && (
        <div className="odin-relative odin-shrink-0 odin-w-full odin-max-w-[22rem] odin-aspect-square odin-m-auto lg:odin-aspect-auto lg:odin-m-0">
          <StaticMap
            className="odin-absolute odin-inset-0 odin-h-full odin-w-full odin-object-cover odin-rounded-2xl"
            url={staticMapUrl}
          />
        </div>
      )}
      <div className="odin-flex odin-flex-1 odin-flex-col odin-gap-4 odin-min-w-0">
        {!loading && jobsite && (
          <>
            <JobsiteInfoCard jobsite={jobsite} baseRoute={baseRoute} />
            <JobsiteSelfOnboardingCard jobsite={jobsite} />
          </>
        )}
      </div>
    </div>
  );
}
